import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  batchId: string;
}

export const useRunRiskAnalysisCalculations = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      await request({
        path: `batches/${batchId}/run-risk-analysis-calculations`,
        method: 'GET',
        authenticate: true,
      });
    },
    onSuccess: () => {
      toast.success('Successfully ran the risk analysis calculations');
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      showErrorToast(error, 'Risk analysis calculations failed!');
    },
  });
};
